<template>
  <div
    v-if="oidcIsAuthenticated"
    class="editProfile"
  >
    <h1>Edit My Profile</h1>
    <h2>Change First Name</h2>
    <ChangeFirstName />
    <h2>Change Last Name</h2>
    <ChangeLastName />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ChangeFirstName from '@/components/ChangeFirstName'
import ChangeLastName from '@/components/ChangeLastName'

export default {
  name: 'editProfile',
  components: { ChangeFirstName, ChangeLastName },
  computed: {
    ...mapGetters('oidcStore', [
      'oidcIsAuthenticated',
      'oidcUser'
    ])
  }
}
</script>
<style>
.change-name p{
  text-align: center;
}
.change-name input[type=text] {
  line-height: 1.5;
  display: block;
  color: rgba(136, 152, 170, 1);
  font-weight: 300;
  width: 94%;
  height: calc(2.75rem + 2px);
  padding: .625rem .75rem;
  border-radius: .25rem;
  background-color: #fff;
  transition: border-color .4s ease;
  border: 1px solid #cad1d7;
  outline: 0;
  margin: 10pt;
}
.change-name input::placeholder{
    text-align: center;
    color: rgb(179, 179, 179);
}
.change-name button{
  font-family: 'Ubuntu', sans-serif;
  transform: translate(-50%, -50%);
  margin-top: 10pt;
  position: absolute;
  left: 50%;
  right: 50%;
  width: 300px;
  /* height: 100%; */
  /* line-height: 1; */
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 1px;
  border: 3px solid #AAC8D1;
  background: #fff;
  color: #AAC8D1;
  border-radius: 40px;
  cursor: pointer;
  overflow: hidden;
  transition: all .35s;
}
.change-name button:hover{
  background: #AAC8D1;
  color: #fff;
}
.change-name button span{
  opacity: 1;
  visibility: visible;
  transition: all .35s;
}
.change-name table, th, td {
  margin-left: auto;
  margin-right: auto;
}
</style>
